import { render } from "./EncounterMessagesComponent.vue?vue&type=template&id=1c142f35&scoped=true"
import script from "./EncounterMessagesComponent.vue?vue&type=script&lang=js"
export * from "./EncounterMessagesComponent.vue?vue&type=script&lang=js"

import "./EncounterMessagesComponent.vue?vue&type=style&index=0&id=1c142f35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c142f35"]])

export default __exports__